<template>
  <b-form-group
    label="13. Penguasaan Fisik"
    label-for="nilaiStrategisBMD"
  >
    <b-form-radio
      v-model="pengamananFisik"
      value="1"
      disabled
    >
      Fisik Dikuasai
    </b-form-radio>
    <b-col
      v-if="pengamananFisik === '1'"
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-radio
        v-model="fisikDikuasai"
        value="1"
        disabled
      >
        Fisik dikuasai seluruh oleh Pemerintah Provinsi DKI Jakarta
      </b-form-radio>
      <b-form-radio
        v-model="fisikDikuasai"
        value="0"
        disabled
      >
        Fisik dikuasai sebagian oleh pihak lain
      </b-form-radio>
      <b-col
        v-if="pengamananFisik === '1' && fisikDikuasai === '0'"
        cols="11"
        offset-md="1"
        class="mt-1 pr-0"
      >
        <b-form-group
          label="Sebutkan"
          label-for="fisikDikuasaiSebutkan"
        >
          <slot name="fisikDikuasaiSebutkan" />
        </b-form-group>
      </b-col>
    </b-col>
    <b-form-radio
      v-model="pengamananFisik"
      value="0"
      disabled
    >
      Fisik Tidak Dikuasai (dikuasai seluruhnya oleh pihak lain)
    </b-form-radio>
    <b-col
      v-if="pengamananFisik === '0'"
      cols="11"
      offset-md="1"
      class="mt-1 pr-0"
    >
      <b-form-group
        label="Sebutkan"
        label-for="fisikTidakDikuasaiSebutkan"
      >
        <slot name="fisikTidakDikuasaiSebutkan" />
      </b-form-group>
    </b-col>
  </b-form-group>
</template>
<script>
export default {
  props: {
    pengamananFisik: { type: String, default: null },
    fisikDikuasai: { type: String, default: null },
  },
}
</script>
